exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thank-you-container{height:80%;width:100%;overflow:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center}.thank-you-container p{margin:0;padding:70px;margin-block:auto;width:600px;background-color:#34596c;color:#fff;font-weight:600;text-align:center;border-radius:8px}@media(max-width:992px){.thank-you-container p{padding:40px;width:100%}}@media(max-width:992px){.thank-you-container{padding-inline:25px}}", ""]);

// exports
